<div
  #wrap
  class="orgg-wrap"
  [class.hovering]="hasHover()"
  [class.is-fullscreen]="isFullscreen()"
  (wheel)="onWheel($event)"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
>
  <div
    class="orgg-viewport"
    [class.smooth]="smooth()"
    [style.width.px]="contentW()"
    [style.height.px]="contentH()"
    [style.transform]="viewportTransform()"
  >
    <svg
      class="orgg-edges"
      [attr.width]="contentW()"
      [attr.height]="contentH()"
      [attr.viewBox]="'0 0 ' + contentW() + ' ' + contentH()"
    >
      @for (edge of renderEdges(); track edge.id) {
        <path class="orgg-line" [class.on-path]="edgeOnPath(edge)" [attr.d]="edge.path" />
      }
    </svg>

    @for (node of renderNodes(); track node.id) {
      <div
        class="orgg-card"
        [class.muted]="node.muted"
        [class.on-path]="isOnPath(node.id)"
        [style.left.px]="node.left"
        [style.top.px]="node.top"
        (mouseenter)="onCardEnter(node.id)"
        (mouseleave)="onCardLeave()"
      >
        <span class="orgg-accent" [style.background]="node.borderColor"></span>

        <span class="orgg-avatar" [style.background]="node.avatarColor">
          @if (node.imageUrl) {
            <img [src]="node.imageUrl" alt="" />
          } @else {
            {{ node.initials }}
          }
        </span>

        <span class="orgg-text">
          <span class="orgg-type" [style.color]="node.borderColor">{{ node.typeLabel }}</span>
          <span class="orgg-title" [ngbTooltip]="node.title">{{ node.title }}</span>
          @if (node.subtitle) {
            <span class="orgg-sub" [ngbTooltip]="node.subtitle">{{ node.subtitle }}</span>
          }
        </span>

        @if (node.hasChildren) {
          <span class="orgg-count">{{ node.childCount }}</span>
          <button
            type="button"
            class="orgg-toggle"
            [class.collapsed]="node.collapsed"
            [attr.aria-label]="node.collapsed ? 'Expand' : 'Collapse'"
            (click)="toggleCollapse(node.id, $event)"
          >
            <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
              <path
                d="M4 6l4 4 4-4"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        }
      </div>
    }
  </div>

  <button
    type="button"
    class="orgg-fullscreen"
    [attr.aria-label]="isFullscreen() ? 'Exit full screen' : 'Full screen'"
    [ngbTooltip]="isFullscreen() ? 'Exit full screen' : 'Full screen'"
    (click)="toggleFullscreen()"
  >
    @if (isFullscreen()) {
      <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
        <path
          d="M6 2v4H2M10 2v4h4M6 14v-4H2M10 14v-4h4"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    } @else {
      <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
        <path
          d="M2 6V2h4M14 6V2h-4M2 10v4h4M14 10v4h-4"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </button>

  @if (legend().length) {
    <div class="orgg-legend">
      <span class="orgg-legend-title">Legend</span>
      @for (item of legend(); track item.kind) {
        <span class="orgg-legend-item">
          <span class="orgg-legend-swatch" [style.background]="item.color"></span>
          {{ item.label }}
        </span>
      }
    </div>
  }

  <div class="orgg-zoom">
    <button type="button" class="orgg-zoom-btn" (click)="zoomOut()" aria-label="Zoom out">
      &#8722;
    </button>
    <button type="button" class="orgg-zoom-level" (click)="fit()" ngbTooltip="Reset to fit">
      {{ zoomPercent() }}
    </button>
    <button type="button" class="orgg-zoom-btn" (click)="zoomIn()" aria-label="Zoom in">+</button>
    <button
      type="button"
      class="orgg-zoom-btn orgg-zoom-fit"
      (click)="fit()"
      aria-label="Fit to screen"
      ngbTooltip="Fit to screen"
    >
      <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
        <path
          d="M2 6V2h4M14 6V2h-4M2 10v4h4M14 10v4h-4"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>
